<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
        <a v-if="edit" href="javascript:;" @click="showDeleteConfirm()" class="button secondary">Slett</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
        <a v-if="edit" href="javascript:;" class="button primary" disabled>Slett</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
        <a v-if="edit" href="javascript:;" class="button primary" disabled>Slett</a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-4" label="Id" v-model.trim="item.id" :disabled="true"/>
              <TheSelectInput containerClassName="cell large-4" label="Ekspertavdeling" name="Expertavdelingsid" required v-validate="'required'" v-model.trim="item.Expertavdelingsid" :items="expertAvdelingOptions"/>
              <TheTextInput containerClassName="cell large-4" label="Merknad tekst" name="Tekst" v-model.trim="item.Tekst" maxlength="255" required v-validate="'required|max:255'"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerLabelEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      expertAvdelingOptions: [],
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      this.expertAvdelingOptions.unshift({key: this.item.Expertavdelingsid, val: 'Laster...'})

      InstillingerService('expertavdeling').dropdown('id')
        .then((response) => {
          let options = []
          response.data.forEach((item) => {
            options.push({ key: item.key, val: item.AvdelingsName + ': ' + item.val })
          })

          this.expertAvdelingOptions = options
          this.expertAvdelingOptions.unshift({key: null, val: 'Velg ekspertavdeling', disabled: true})

          if (!this.edit) {
            this.setFormLoading(false)
          } else {
            this.service.view(this.$route.params.id)
              .then((response) => {
                this.item = response.data
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn merknad')

                this.onCancel()
              })
              .then(() => {
                this.setFormLoading(false)
              })
          }
        })
    },
    showDeleteConfirm: function () {
      let vm = this

      this.openConfirm(
        'Slett merknad',
        'Er du sikker på at du vil slette merknaden?',
        'Ja',
        'Nei',
        function () {
          vm.service.delete(vm.item.id)
            .then((response) => {
              vm.closeModal()
              vm.$router.go(-1)
            })
            .catch(() => {
              vm.closeModal()
              vm.$helpers.showErrorAlert('Feil', 'Kunne ikke slette merknad')
            })
        },
        function () {
          vm.closeModal()
        }
      )
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.service.save(this.item.id, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Merknad er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerMerknadEdit.vue